"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "attendeeRosterEmitter", {
  enumerable: true,
  get: function get() {
    return _attendeeRosterEmitter["default"];
  }
});
var _attendeeRosterEmitter = _interopRequireDefault(require("./attendeeRosterEmitter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }